<template>
  <div class="home max">
    <div class="banner">
      <img
        class="banner_img"
        src="../../static/img/lpfw_banner.png"
        alt=""
      >
    </div>
    <div class="content w1200">
      <ul class="con_left">
        <img
          src="../../static/img/lpfw_lpfw.png"
          alt=""
        >
        <li
          v-for="(item,i) in lpList"
          :key="i"
          @mousemove="active = i"
          :class="{ active: active === i }"
        >
          {{item.name}}
        </li>
      </ul>
      <div class="con_right">
          <div  v-if="active === 0">

         <h4> 理赔服务说明</h4>
         
<p>理赔注意事项提示</p>

<p>
一．充分了解您所投保的保险产品</p>
<p>很多客户并没有意识到充分了解保险产品的责任内容，特别是责任免除内容对准确、客观的选择保险产品的重要意义。很多消费者由于投保产品没有做到充分的理解，因此等到发生事故申请理赔时，才了解到有些事件是不符条款约定，保险公司不承担赔偿责任。因此，详细了解保险条款尤其是责任免除条款显的格外重要。 
</p>
<p>二．了解关于保险理赔时效的规定</p>
<p>相关法律规定保险公司在收到权利人理赔书面申请以及完整齐全的理赔材料后，应当及时作出核定，情形复杂的，也应当在30天内作出核定并及时支付保险金；对属于合同条款约定保险责任的，保险公司应当在理赔结案后或者在双方达成理赔协议后10天之内支付理赔保险金；对于不属于约定保险责任而不予赔付的，应当自作出核定之日起3天内发出拒绝赔付的书面通知并要说明不予赔付的理由。</p>

<p>三．及时报案：在3日内向保险公司报案</p>
<p>保险事故发生后，及时报案是获得快速理赔的基础和重要保证。您可以拨打各承保保险公司客服专线及时报案。报案的越早越快，对理赔越有利。当发生疾病等事故时，一定要立即通知保险公司，否则有可能因未及时通知，要承担保险公司因此增加的调查费用。意外险的被保险人发生意外伤害或住院后，应当及时报案，一般应在3日内报案。 </p>

<p>四．提出有效、齐全的理赔申请材料</p>
<p>要想顺利快速完成理赔，特别提醒注意保存好各类证明单据（医疗、财务等）。根据保险种类不同，索赔时应提供的资料也不一样，具体可在飞猪保险网理赔指南中查询。</p>

<p>五．到保险公司指定医院就诊</p>
<p>通常，保险公司会在健康医疗类保险产品条款中约定，被保险人在指定医疗机构范围内进行按照约定的形式治疗是做为赔付的基本条件。目前境内的各家保险公司指定医院的范围基本上都是“当地的二级及以上（含二级）公立性医院”，一般包含境内县区级（含）以上的公立医院。因此被保险人在需要治疗时，一定要在保险公司指定的医院或范围内就诊治疗。若因特殊原因需选择以外的医院治疗时，需要征得承保保险公司的同意，否则将有可能不予赔付。对于医疗各项费用的理赔申请，除提交收据原件以外，还要提供完整的费用明细清单，保险公司在理赔时通常需审核费用明细以确定是否属于保险责任。</p>
 </div>
 <div  v-if="active === 1">
     
     <h4>理赔报案电话</h4>
<p> 一、保险事故发生后您可以通过以下方式向协和万邦保险网报案</p>保险经纪有限公司
    <p>

            1、协和万邦保险客户服务专线</p>
<p>
               400-665-0265 (周一到周日，服务时间：8：30～20：30)</p>
<p> 2、协和万邦保险在线客服</p>
           
<p>在线客服 (服务时间：8：30～20：30)</p>
               
<p> 二、您也可以通过拨打下列电话号码，向保险公司报案</p>
 <table
            width="870"
            border="1"
            cellspacing="0"
            cellpadding="0"
          >
    <tr>
        <td>保险公司</td>
        <td>报案电话</td>
        <td>保险公司</td>
        <td>报案电话</td>
    </tr>
    <tr>
        <td>中国平安</td>
        <td>95511</td>
        <td>大都会人寿</td>
        <td>4008-188-168</td>

    </tr>
     <tr>
        <td>泰康人寿</td>
        <td>95522</td>
        <td>阳光财险</td>
        <td>95510</td>

    </tr>
     <tr>
        <td>中国太平洋</td>
        <td>95500</td>
        <td>美国友邦</td>
        <td>800-8203588、
            400-8203588
        </td>

    </tr>
    <tr>
        <td>华泰财产</td>
        <td>40060-95509</td>
        <td>中国人保</td>
        <td>95518</td>

    </tr>
    <tr>
        <td>合众人寿</td>
        <td>95515</td>
        <td>昆仑保险</td>
        <td>4008-118-899</td>

    </tr>
   <tr>
        <td>美亚财产</td>
        <td>4008-208-858</td>
        <td>都邦保险</td>
        <td>95586</td>
    </tr>
    <tr>
        <td>法国安盛</td>
        <td>4008-818-158</td>
        <td>华安保险</td>
        <td>95556</td>
    </tr>
    <tr>
        <td>大众保险</td>
        <td>4009-995-507</td>
        <td>平安车险</td>
        <td>95511</td>
    </tr>
    <tr>
        <td>太平养老</td>
        <td>95589</td>
        <td>太平洋车险</td>
        <td>95500</td>
    </tr>
    <tr>
        <td>阳光车险</td>
        <td>95510</td>
        <td>大地车险</td>
        <td>95590</td>
    </tr>
 </table>			

 </div>
 <div  v-if="active === 2">
     <h4> 理赔办理流程</h4>
     <p>理赔办理流程</p>
    
     <p>第一步：发生保险事故后，请第一时间理赔报案。您可以直接向保险公司报案，也可以请协和万邦保险协助报案。协和万邦保险为您开通客服专线400-665-0265、 在线客服以及客服邮箱等多种报案协助申请方式；</p>
<p>第二步：请您收集、整理、提交理赔材料进行理赔申请。为了最大程度缩短理赔时间，理赔材料 齐全后，可直接快递至相应保险公司。</p>

<p>第三步：保险公司收到申请材料以后，会开启"协和万邦保险理赔特别通道"，会很快的完成理赔案件的审核。</p>

<p>第四步：理赔审核完成后，理赔结果会及时通知您！也请您及时查看您申请理赔的银行账户，确认钱款是否及时到帐。</p>
<p>理赔电话</p>
<table
            width="870"
            border="1"
            cellspacing="0"
            cellpadding="0"
          >
    <tr>
        <td>保险公司</td>
        <td>报案电话</td>
        <td>保险公司</td>
        <td>报案电话</td>
    </tr>
    <tr>
        <td><img src="../../static/img/t1.gif" alt=""></td>
        <td>95518</td>
       <td><img src="../../static/img/t2.gif" alt=""></td>
        <td>40060-95509</td>
    </tr>
    <tr>
      <td><img src="../../static/img/t3.gif" alt=""></td>
        <td>4008-188-168</td>
        <td><img src="../../static/img/t4.gif" alt=""></td>
        <td>4008-118-899</td>
    </tr>
    <tr>
        <td><img src="../../static/img/t5.gif" alt=""></td>
        <td>95511</td>
        <td><img src="../../static/img/t6.gif" alt=""></td>
        <td>95586</td>
    </tr>
    <tr>
        <td><img src="../../static/img/t7.gif" alt=""></td>
        <td>95586</td>
        <td><img src="../../static/img/t8.gif" alt=""></td>
        <td>95556</td>
    </tr>
    <tr>
        <td><img src="../../static/img/t9.gif" alt=""></td>
        <td>95500</td>
        <td><img src="../../static/img/t10.png" alt=""></td>
        <td>95589</td>
    </tr>
    <tr>
       <td><img src="../../static/img/t11.png" alt=""></td>
        <td>95515</td>
        <td><img src="../../static/img/t12.png" alt=""></td>
        <td>4008-818-158</td>
    </tr>
    <tr>
        <td><img src="../../static/img/t13.gif" alt=""></td>
        <td>4008-208-858</td>
        <td><img src="../../static/img/t14.gif" alt=""></td>
        <td>800-8203588、
400-8203588</td>
    </tr>
    <tr>
       <td><img src="../../static/img/t15.gif" alt=""></td>
        <td>4009-995-507</td>
       <td><img src="../../static/img/t16.gif" alt=""></td>
        <td>95510</td>
    </tr>
    <tr>
        <td><img src="../../static/img/t17.gif" alt=""></td>
        <td>400-820-5918</td>
        <td><img src="../../static/img/t18.gif" alt=""></td>
        <td>95590</td>
    </tr>

 </table>			


 </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      active: 0,
      lpList: [
        {
          name: "理赔服务说明"
        },
        {
          name: "理赔报案电话"
        },
        {
          name: "理赔服务助手"
        }
      ],
      lpContent: [
        {
          id: 0,
          title: "理赔服务说明",
          text:
            "理赔注意事项提示",
          text1:
            "一．充分了解您所投保的保险产品",
          text2:
            "很多客户并没有意识到充分了解保险产品的责任内容，特别是责任免除内容对准确、客观的选择保险产品的重要意义。很多消费者由于投保产品没有做到充分的理解，因此等到发生事故申请理赔时，才了解到有些事件是不符条款约定，保险公司不承担赔偿责任。因此，详细了解保险条款尤其是责任免除条款显的格外重要。 ",
          text3:
            "二．了解关于保险理赔时效的规定",
          text4:
            "四、互联网保险业务的销售、承保、理赔、退保、投诉处理及客户服务等保险经营行为，均由本公司管理和负责，不具有保险业务资格的第三方网络平台仅提供网络技术支持辅助服务。",
          text5:
            "本公司保证所提供材料真实、完整，自觉接受监管部门和行业组织的监督管理。本公司承诺对互联网保险业务经营行为承担完全法律责任。",
             text6: "（四）许可证有效期:2018年09月29日",
          text7:
            "（五）业务范围：在全国区域内（港、澳、台除外）为投保人拟定投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国保监会批准的其他业务。",
          text8: "（六）联系方式：4006650265",
          text9:
            "二、请仔细阅读保险条款，重点关注保险责任、责任免除、被保险人权利义务、免赔额或免赔率的计算、犹豫期解除合同、退保损失、保险新型产品费用扣除及投资风险、健康保险产品等待期等内容，并可要求本公司业务人员对上述内容进行详细讲解。",
          text10:
            "三、请向本公司业务人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同中止与失效、未成年人投保限额、保险标的转让、重复保险等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄不真实等情形导致的法律后果。",
          text11:
            "四、根据《中华人民共和国保险法》的规定，保险经纪机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。",
          text12:
            "五、本公司已按《保险专业经纪机构监管规定》投保职业责任保险。",
          text13:
            "六、如果您发现本公司从业人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向保监局或当地保险行业协会反映。"
        },
        {
          id: 1
          // title: '',
        },
        {
          id: 2
          // title: '自营网络平台（网站）产品信息',
        },
        {
          id: 3,
          title: "客户告知书",
          text: "尊敬的客户：",
          text1:
            "感谢您选择我公司为您办理保险业务。本公司是依据投保人的利益，为投保人与保险公司订立保险合同提供中介服务的保险专业中介机构，按照《保险经纪机构监管规定》的要求，本公司应履行客户告知义务，现将有关事项告知如下，请仔细阅读。",
          text2: "一、公司基本情况",
          text3: "（一）名称:天津协和万邦保险经纪有限公司",
          text4: "（二）机构住所：天津市武清开发区福源道北侧",
          text5:
            "（三）许可证名称及机构编码： 经营保险经纪业务许可证，2605540000800",
          text6: "（四）许可证有效期:2018年09月29日",
          text7:
            "（五）业务范围：在全国区域内（港、澳、台除外）为投保人拟定投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国保监会批准的其他业务。",
          text8: "（六）联系方式：4006650265",
          text9:
            "二、请仔细阅读保险条款，重点关注保险责任、责任免除、被保险人权利义务、免赔额或免赔率的计算、犹豫期解除合同、退保损失、保险新型产品费用扣除及投资风险、健康保险产品等待期等内容，并可要求本公司业务人员对上述内容进行详细讲解。",
          text10:
            "三、请向本公司业务人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同中止与失效、未成年人投保限额、保险标的转让、重复保险等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄不真实等情形导致的法律后果。",
          text11:
            "四、根据《中华人民共和国保险法》的规定，保险经纪机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。",
          text12:
            "五、本公司已按《保险专业经纪机构监管规定》投保职业责任保险。",
          text13:
            "六、如果您发现本公司从业人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向保监局或当地保险行业协会反映。"
        }
      ]
    };
  }
};
</script>

<style  lang="scss" scoped>
.content {
  background-color: #fff;
  padding: 60px 10px;
  display: flex;
  justify-content: space-between;
  .con_left {
    height: 500px;
    width: 223px;
    background-color: #5182c4;
    li {
      text-align: center;
      height: 60px;
      line-height: 60px;
      margin-top: 20px;
      font-weight: 600;
      color: #fffcfa;
    }
    .active {
      background-color: #f4f4f4;
      color: #5786b0;
    }
  }
  .con_right {
    padding: 0 40px;
    color: #656565;
    h4 {
      font-size: 28px;
      color: #598ac2;
      text-align: center;
      padding-bottom: 40px;
    }
    p {
      padding-bottom: 10px;
      text-indent: 2em;
    }
    table {
      font-size: 18px;
      color: #606060;
      td {
        padding: 5px;
        text-align: center;
        img{
            display: inline-block;
            margin: 0 auto;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Lpfw.vue